import {Component, OnDestroy} from '@angular/core';
import {Register} from './register.service';
@Component({
    selector: 'jhi-register',
    templateUrl: './register.component.html'
})
export class RegisterComponent implements OnDestroy {

    constructor(private registerService: Register) {   }

    ngOnDestroy(): void {
        this.registerService.reset();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register.component.ts